module.exports = __webpack_public_path__ + "static/media/logos.c0686aea.svg";